import React, {Component} from "react";
import T from "../t/T";
import "./Popover.scss";
import {Popover as PopoverAntd} from 'antd';
import colors from '../../../assets/scss/variable/color.scss';
import {connect} from "react-redux";

class Popover extends Component {
    constructor(props) {
        super(props);

        this.state = {
            direction: this.props.direction,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.language !== this.props.language) {
            this.setState({language: this.props.language});
        }
    }

    render() {
        const {
            show = false,
            className= "popover_class_name",
            title = "title",
            textToShow = "empty_error",
            closePopover = (e) => {console.log("onOpenChange", e)},
            children = null
        } = this.props;

        return <PopoverAntd
            open={show}
            overlayClassName={className}
            onOpenChange={closePopover}
            trigger="click"
            placement="bottomLeft"
            arrow={{pointAtCenter: true}}
            color={colors.gray_4D}
            overlayStyle={{
                direction: this.state.direction,
                ...this.props?.style
            }}
            title={() =>
                <div className={"text-center py-2 pb-3"} style={{color: colors.white}}>
                    <T token={title}/>
                </div>}
            content={() => <span style={{color: colors.white_b2}}>
                {children ?? <T token={textToShow}/>}
            </span>}
        />
    }
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const direction = state.LangReducer.direction;
    return {language, direction};
};

export default connect(mapStateToProps)(Popover);